import { INVOICE_PAYOR_TYPE_LIST_REQUEST, INVOICE_PAYOR_TYPE_LIST_RECEIVED, INVOICE_PAYOR_TYPE_LIST_ERROR } from '../constants';

const reducer = (
  state = {
    invoicePayorTypes: [],
    isFetchingInvoicePayorTypes: false,
  },
  action,
) => {
  switch (action.type) {
    case INVOICE_PAYOR_TYPE_LIST_REQUEST:
      state = {
        ...state,
        isFetchingInvoicePayorTypes: true,
      };
      return state;

    case INVOICE_PAYOR_TYPE_LIST_RECEIVED:
      state = {
        ...state,
        invoicePayorTypes: action.data['hydra:member'],
        isFetchingInvoicePayorTypes: false,
      };
      return state;

    case INVOICE_PAYOR_TYPE_LIST_ERROR:
      state = {
        ...state,
        isFetchingInvoicePayorTypes: false,
      };
      return state;

    default:
      return state;
  }
};

export default reducer;
